import { CustomFieldRecord, CustomFieldType } from "./CustomFieldRecord";

/** Keys understood by the shared `FieldTypeIcon` component. */
type FieldTypeIconKey = "string" | "numeric" | "date" | "boolean" | "enum";

// These keys are the `FilterDefinition` types the search builders map custom
// fields to, so the field-picker icon matches the Settings table by
// construction. Keyed by the full enum so a new member fails to compile until
// its icon key is added here.
const TYPE_ICON_KEYS: Record<CustomFieldType, FieldTypeIconKey> = {
  [CustomFieldType.String]: "string",
  [CustomFieldType.Number]: "numeric",
  [CustomFieldType.Timestamp]: "date",
  [CustomFieldType.Boolean]: "boolean",
  [CustomFieldType.Enum]: "enum",
};

export function customFieldTypeIconType(
  type: CustomFieldType,
): FieldTypeIconKey {
  return TYPE_ICON_KEYS[type];
}

/** Label shown for a field, defaulting to the field name when no display name is set. */
export function customFieldDisplayName(field: CustomFieldRecord): string {
  return field.display_name ?? field.field_name;
}
